import { routes as widget } from './widget'
import { routes as channel } from './channel'
import { routes as institution } from './institution'
import { routes as user } from './user'
import { routes as course } from './course'

export default [ ...widget, ...channel, ...institution, ...user, ...course ]



// WEBPACK FOOTER //
// ./src/app/ChannelWidgetRoutes.js